import { render, staticRenderFns } from "./MyCalculator.vue?vue&type=template&id=c0c8f8b4"
import script from "./MyCalculator.vue?vue&type=script&lang=js"
export * from "./MyCalculator.vue?vue&type=script&lang=js"
import style0 from "./MyCalculator.vue?vue&type=style&index=0&id=c0c8f8b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports